import { styled } from "styled-components";

import { colorCSS, fontSizes } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Footer = styled.footer`
    ${redundantCssFromKebab("font-size", `${fontSizes.xs}`)}
    ${redundantCssFromKebab("margin", "1.25rem 0")}

    select {
        ${redundantCssFromKebab("border", `2px solid ${colorCSS("N30")}`)}
        ${redundantCssFromKebab("color", `${colorCSS("N300")}`)}
        ${redundantCssFromKebab("padding", "0.25rem 0.5rem")}
        ${redundantCssFromKebab("background-position", "center right 0.5rem")}
        ${redundantCssFromKebab("margin", "1rem 0 0.5rem")}
    }

    svg {
        ${redundantCssFromKebab("color", `${colorCSS("B400")}`)}
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("margin", "1.25rem 0")}
        ${redundantCssFromKebab("width", "150px")}
    }

    .tagline p {
        ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
        ${redundantCssFromKebab("margin", "1rem 0 0")}
    }
`;

export const Links = styled.nav`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-wrap", "wrap")}

    a,
    button {
        ${redundantCssFromKebab("color", `${colorCSS("N300")}`)}
        ${redundantCssFromKebab("padding", "0.125rem 0.75rem")}
        ${redundantCssFromKebab("text-decoration", "none")}

        &:hover {
            ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
            ${redundantCssFromKebab("text-decoration", "underline")}
        }
    }
`;
